module.exports = __webpack_public_path__ + "img/hood_depth.a1e8117a.png";